export enum PayCurrency {
  WON = "410",
  USD = "840",
}
